import { render, staticRenderFns } from "./leftnavbar.vue?vue&type=template&id=72feed1f"
import script from "./leftnavbar.vue?vue&type=script&lang=js"
export * from "./leftnavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports